import React from "react"
import {FieldViewProps} from "../../../../render/view";


export default function FieldTimeOfDay_View(props: FieldViewProps) {

    const value = props.field.getViewValue(props.model)


    return (
        <div className={Classes("ui5-txt-default", "fl-ac", props.className)}>
            <span className="txt-truncate">{props.field.getDisplayValue(value)}</span>
        </div>
    );

}
